import React, { Component } from "react";
import debounce from "lodash.debounce";

import _ from "i18n";

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = { inputValue: props.searchInputValue || "" };
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 1000);
  }

  handleKeyPress = event => {
    if (event.key === "Enter") {
      this.props.onChange(event.target.value);
    }
  };

  debounceSearchHandler = event => {
    this.setState({ inputValue: event.target.value });
    this.handleSearchInputChange(event.target.value);
  };

  handleSearchInputChange = value => {
    this.props.onChange(value);
  };

  clearAll = () => {
    this.setState({ inputValue: "" });
    this.handleSearchInputChange("");
  };
  getSearchValueStyle = () => {
    return {
      background: "#F1F2F4",
      display: "flex",
      width: "44px",
      height: "19px",
      borderRadius: "13px",
      alignItems: "center",
      justifyContent: "center"
    };
  };

  render() {
    const { placeholder, nbResult, searchInputValue, fetching } = this.props;
    const { inputValue } = this.state;

    return (
      <div className="search-box">
        <span className="search-box__icon">
          <img src={"/img/icons/search.svg"} alt={""} />
        </span>
        <input
          value={
            inputValue !== "undefined" ? inputValue : (this.clearAll(), "")
          }
          placeholder={`${_(placeholder || "search")} ...`}
          onChange={this.debounceSearchHandler}
          onKeyPress={this.handleKeyPress}
        />
        {inputValue &&
        searchInputValue &&
        searchInputValue.length > 2 &&
        !fetching &&
        nbResult ? (
          <div style={this.getSearchValueStyle()}>{nbResult}</div>
        ) : (
          ""
        )}
        {inputValue &&
          inputValue.length && (
            <img
              className="icomoon icon-tt-close"
              src="/img/icons/close.svg"
              alt={""}
              onClick={this.clearAll}
            />
          )}
      </div>
    );
  }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/Common/filters/SearchBox.js